import { render } from "./GajiPokokTableTemplate.vue?vue&type=template&id=4cc9f2f3&scoped=true"
import script from "./GajiPokokTableTemplate.vue?vue&type=script&lang=js"
export * from "./GajiPokokTableTemplate.vue?vue&type=script&lang=js"

import "./GajiPokokTableTemplate.vue?vue&type=style&index=0&id=4cc9f2f3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc9f2f3"]])

export default __exports__